"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoBuffer = void 0;
const ethers_1 = require("ethers");
/**
 * 암호화에 사용할 바이너리 데이터를 표현합니다.
 * 필요에 따라 hex string, byte array 등으로 바꿀 수 있습니다.
 */
class CryptoBuffer {
    constructor(hex, length) {
        CryptoBuffer.ensureHexString(hex);
        CryptoBuffer.checkLength(hex, length);
        this.hex = hex;
        this.length = length;
    }
    static empty() {
        return new CryptoBuffer('', 0);
    }
    static fromUint8Array(array) {
        return new CryptoBuffer(uint8ArrayToHex(array), array.length);
    }
    static fromHex(hex, length) {
        // TODO: check length
        return new CryptoBuffer(hex, length);
    }
    static ensureHexString(hex) {
        try {
            if (hex === '') {
                return;
            }
            if (hex == null) {
                throw new Error(`hex is null ${hex}`);
            }
            if (!hex.startsWith('0x')) {
                throw new Error(`hex does not start with 0x ${hex}`);
            }
            if (hex.match('0x[0-9a-fA-F]+') == null) {
                throw new Error(`invalid hex data ${hex}`);
            }
        }
        catch (e) {
            throw e;
        }
    }
    static checkLength(hex, length) {
        if (hex.length === 0) {
            return;
        }
        const bytesLength = ((hex.length - 2) * 4) / 8;
        if (bytesLength > length) {
            throw new Error(`length is less than hex data ${hex}, ${length}`);
        }
    }
    toString() {
        return this.hex;
    }
    toHex() {
        return this.hex;
    }
    toBigNumber() {
        return ethers_1.BigNumber.from(this.hex);
    }
    toJSON() {
        return JSON.stringify({
            hex: this.hex,
            length: this.length,
        });
    }
    static fromJSON(jsonStr) {
        const { hex, length } = JSON.parse(jsonStr);
        return new CryptoBuffer(hex, length);
    }
    static fromBigNumber(source, length) {
        return CryptoBuffer.fromHex(source.toHexString(), length);
    }
    // TODO: add test
    toUInt8Array() {
        const hex = this.hex.substring(2);
        const result = [];
        for (let i = 0; i < hex.length; i += 2) {
            result.push(parseInt(hex.substring(i, i + 2), 16));
        }
        return new Uint8Array(result);
        //
        // const numberArray = this.hex.match(/.{1,2}/g)!.map(x => parseInt(x, 16));
        // const buffer = new Uint8Array(numberArray.length);
        // buffer.set(numberArray);
        // return buffer;
    }
    static concat(elem1, elem2) {
        try {
            const e1 = elem1.toUInt8Array();
            const e2 = elem2.toUInt8Array();
            const newBuffer = new Uint8Array(e1.length + e2.length);
            newBuffer.set(e1);
            newBuffer.set(e2, e1.length);
            const mergedHex = uint8ArrayToHex(newBuffer);
            return new CryptoBuffer(mergedHex, e1.length + e2.length);
        }
        catch (e) {
            return CryptoBuffer.empty();
        }
        return CryptoBuffer.empty();
    }
    split(firstLength) {
        const array = this.toUInt8Array();
        return [
            CryptoBuffer.fromUint8Array(array.slice(0, firstLength)),
            CryptoBuffer.fromUint8Array(array.slice(firstLength)),
        ];
        // first = new Uint8Array();
    }
    clone() {
        return new CryptoBuffer(this.hex, this.length);
    }
    unsafeSetLength(length) {
        this.length = length;
    }
}
exports.CryptoBuffer = CryptoBuffer;
function uint8ArrayToHex(newBuffer) {
    return '0x' + [...newBuffer].map((x) => x.toString(16).padStart(2, '0')).join('');
}
//# sourceMappingURL=crypto.js.map